import { Controller } from "@hotwired/stimulus"

/**
 * Loading Stimulus Controller
 *
 * Adds a loading state to forms/links for visual feedback.
 *
 * Usage:
 *   <form data-controller="loading" data-action="submit->loading#start">
 *     <button type="submit" data-loading-target="button" data-loading-text="Saving...">
 *       Save
 *     </button>
 *   </form>
 *
 *   <a href="..." data-controller="loading" data-action="click->loading#start"
 *      data-loading-target="button" data-loading-text="Loading...">View</a>
 */
export default class extends Controller {
  static targets = ["button", "spinner"]

  start() {
    this.buttonTargets.forEach(button => {
      const loadingText = button.dataset.loadingText || "Loading..."
      button.dataset.originalText = button.innerText
      button.innerText = loadingText
      button.disabled = true
      button.classList.add("opacity-70", "cursor-wait")
    })

    this.spinnerTargets.forEach(spinner => {
      spinner.classList.remove("hidden")
    })
  }

  stop() {
    this.buttonTargets.forEach(button => {
      if (button.dataset.originalText) {
        button.innerText = button.dataset.originalText
      }
      button.disabled = false
      button.classList.remove("opacity-70", "cursor-wait")
    })

    this.spinnerTargets.forEach(spinner => {
      spinner.classList.add("hidden")
    })
  }
}
